<template>
  <div>
    <b-card header-tag="header" class="mb-3">
      <!-- 헤더 -->
      <div slot="header">
        <i class="fa fa-bars"></i> <strong>데이터 파일</strong>
      </div>
      <!-- 바디 -->
      <div>
        <b-row class="mb-2">
          <b-col cols="12" class="float-right">
            <!-- 검색어 -->
            <b-form inline class="float-right" @submit.prevent.stop="handleSearchClicked">
              <b-input-group>
                <b-form-select v-model="param.searchSiteValue" variant="outline-secondary" class="mr-1" :options="siteOptions" @change="handleSiteChanged">
                  <option value="__WORLD__-__VERSION__">전세계</option>
                </b-form-select>
                <b-form-select v-model="param.searchMapTypeId" variant="outline-secondary" class="mr-1" :options="mapTypeOptions" @change="handleMapTypeChanged">
                </b-form-select>
                <b-input-group-prepend>
                  <b-form-select v-model="param.searchKind" variant="outline-secondary">
                    <option value="dataFileName">파일명</option>
                    <option value="mainVersion">주버전</option>
                    <option value="baseYmd">기준년월일</option>
                  </b-form-select>
                </b-input-group-prepend>
                <b-form-input type="text" v-model="param.searchWord" placeholder="검색어 입력"/>
                <b-input-group-append>
                  <b-button v-ripple variant="outline-secondary" @click.stop="handleClearClicked">
                    <i class="fa fa-close"></i>
                  </b-button>
                </b-input-group-append>
                <b-input-group-append>
                  <b-button v-ripple variant="info" @click.stop="handleSearchClicked" class="ml-1">
                    <i class="fa fa-search"></i>
                  </b-button>
                </b-input-group-append>
                <b-input-group-append>
                  <b-button v-ripple variant="primary" @click.stop="handleAddClicked" class="ml-1">
                    <i class="fa fa-plus"></i>
                  </b-button>
                </b-input-group-append>
                <b-input-group-append>
                  <b-button v-ripple variant="secondary" @click.stop="handleLinkValidationClicked" class="ml-1">
                    링크 검증
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <!-- table -->
            <b-table outlined responsive no-local-sorting :foot-clone="true"
                     :fields="fields"
                     :items="items">
              <!-- 사이트ID -->
              <template slot="siteId" slot-scope="data">
                <b-form-select v-model="data.item.siteValue"
                               :style="formBackgroundColor(data)"
                               :options="siteOptions"
                               :disabled="formFieldReadOnly(data)"
                               @change="handleSiteInputChanged(data)">
                </b-form-select>
              </template>
              <!-- 맵타입 -->
              <template slot="mapTypeId" slot-scope="data">
                <b-form-select v-model="data.item.mapTypeId"
                               :style="formBackgroundColor(data)"
                               :options="mapTypeOptions"
                               :disabled="formMapTypeReadOnly(data)"
                               @change="handleMapTypeInputChanged(data)">
                </b-form-select>
              </template>
              <!-- 파일확장자 -->
              <template slot="fileExtension" slot-scope="data">
                <b-form-select v-model="data.item.fileExtension"
                               :style="formBackgroundColor(data)"
                               :disabled="formFieldReadOnly(data)"
                               @change="handleFileExtensionChanged(data)">
                  <option value=""> - 확장자 - </option>
                  <option value="map">map</option>
                  <option value="db">db</option>
                  <option value="ndb">ndb</option>
                  <option value="cfg">cfg</option>
                </b-form-select>
              </template>
              <!-- 파일명 -->
              <template slot="dataFileName" slot-scope="data">
                <b-form-input type="text" placeholder="eTileType_Road"
                              v-model="data.item.dataFileName"
                              :style="formBackgroundColor(data)"
                              :disabled="formFieldReadOnly(data)"
                              @change="handleColumnChanged(data)"/>
              </template>
              <!-- 주버전 -->
              <template slot="dataFileVersion" slot-scope="data">
                <b-input-group>
                  <b-form-input type="text" placeholder="4" v-model="data.item.mainVersion"
                                :style="formBackgroundColor(data)"
                                style="width:40px;"
                                class="mr-1"
                                @change="handleColumnChanged(data)"/>
                  <b-form-input type="number" placeholder="0" v-model="data.item.subVersion"
                                :style="formBackgroundColor(data)"
                                style="width:40px;"
                                @change="handleColumnChanged(data)"/>
                </b-input-group>
              </template>
              <!-- 기준년월일 -->
              <template slot="baseYmd" slot-scope="data">
                <b-form-input type="text" placeholder="20180608" v-model="data.item.baseYmd"
                              :style="formBackgroundColor(data)"
                              style="width:120px;"
                              @change="handleColumnChanged(data)"/>
              </template>
              <!-- 링크 검증 -->
              <template slot="linkStatus" slot-scope="data">
                <b-button v-ripple :id="'linkStatus' + data.index" class="mr-1 py-1" :variant="linkStatusColor(data)">{{ data.item.linkStatus }}</b-button>
                <b-popover :target="'linkStatus' + data.index" triggers="hover" placement="lefttop">
                  <template slot="title">{{ data.item.linkStatus }}</template>
                  <span class="text-primary">{{ data.item.linkStatusMessage }}</span>
                </b-popover>
              </template>
              <!-- 액션 버튼 -->
              <template slot="action" slot-scope="data">
                <b-row>
                  <b-col class="text-right">
                    <b-button-group class="">
                      <c-switch type="text" size="lg" variant="secondary" class="mr-1" on="ON"
                                :checked="data.detailsShowing"
                                @change="data.toggleDetails"/>
                      <b-button v-ripple variant="outline-primary" @click="handleSaveClicked(data)" class="mr-1">
                        <i class="fa fa-check"></i>
                      </b-button>
                      <b-button v-ripple variant="outline-danger" @click="handleDeleteClicked(data)">
                        <i class="fa fa-trash"></i>
                      </b-button>
                    </b-button-group>
                  </b-col>
                </b-row>
              </template>
              <!-- 상세 -->
              <template slot="row-details" slot-scope="data" class="table-orange">
                <!-- 원본파일 위치 -->
                <b-row class="mb-1">
                  <b-col>
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text>원본파일 위치</b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input id="filePath" type="text" placeholder="파일이 실제 위치한 경로"
                                    v-model="data.item.filePath"
                                    :style="formBackgroundColor(data)"/>
                      <b-input-group-append>
                        <b-button v-ripple variant="outline-secondary" class="px-3"
                                  @click.stop="handleFilePathSupportClicked(data)">
                          자동 생성
                        </b-button>
                      </b-input-group-append>
                      <b-input-group-append>
                        <b-button v-ripple variant="outline-secondary"
                                  @click.stop="handleFilePathClearClicked(data)">
                          <i class="fa fa-close"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-col>
                </b-row>
                <!-- 타일요청 경로 -->
                <b-row class="mb-1">
                  <b-col>
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text>타일요청 경로</b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input id="tileUrl" type="text" placeholder="파일 확장자가 map 인 경우이거나 voiceex.db 파일만 입력 가능"
                                    v-model="data.item.tileUrl"
                                    :style="formBackgroundColor(data)"
                                    :disabled="formTileReadOnly(data)"/>
                      <b-input-group-append>
                        <b-button v-ripple variant="outline-secondary" class="px-3"
                                  @click.stop="handleTileUrlSupportClicked(data)"
                                  :disabled="formTileReadOnly(data)">
                          자동 생성
                        </b-button>
                      </b-input-group-append>
                      <b-input-group-append>
                        <b-button v-ripple variant="outline-secondary"
                                  @click.stop="handleTileUrlClearClicked(data)"
                                  :disabled="formTileReadOnly(data)">
                          <i class="fa fa-close"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-col>
                </b-row>
                <!-- 다운로드 경로 -->
                <b-row class="mb-1">
                  <b-col>
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text>다운로드 경로</b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input type="text" placeholder="사이트를 선택한 경우에만 입력 가능"
                                    v-model="data.item.downloadUrl"
                                    :style="formBackgroundColor(data)"
                                    :disabled="formDownloadReadOnly(data)"/>
                      <b-input-group-append>
                        <b-button v-ripple variant="outline-secondary" class="px-3"
                                  @click.stop="handleDownloadUrlSupportClicked(data)"
                                  :disabled="formDownloadReadOnly(data)">
                          자동 생성
                        </b-button>
                      </b-input-group-append>
                      <b-input-group-append>
                        <b-button v-ripple variant="outline-secondary"
                                  @click.stop="handleDownloadUrlClearClicked(data)"
                                  :disabled="formDownloadReadOnly(data)">
                          <i class="fa fa-close"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-col>
                </b-row>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="10">
            <b-pagination size="md" v-model="paging.currentPage" :total-rows="paging.totalRows" :per-page="paging.perPage" @change="handleCurrentPageChanged">
            </b-pagination>
          </b-col>
          <b-col md="2">
            <b-form-select v-model="paging.perPage" :options="paging.pageOptions" @change="handlePerPageChanged" />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            ▶︎ 사이트 미 선택시 전세계(World) 파일로 처리됩니다.
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import cSwitch from '../components/Switch.vue'
import path from 'path'

export default {
  components: {
    cSwitch
  },
  data () {
    return {
      param: {
        searchSiteValue: '-',
        searchSiteId: '',
        searchSiteVersion: '',
        searchMapTypeId: '',
        searchKind: 'dataFileName',
        searchWord: null,
        page: 0,
        size: 0
      },
      fields: [
        { key: 'siteId', label: '사이트', class: 'w-18' },
        { key: 'mapTypeId', label: '맵타입', class: 'w-10' },
        { key: 'fileExtension', label: '파일 확장자', class: 'w-10' },
        { key: 'dataFileName', label: '데이터 파일', class: 'w-20' },
        { key: 'dataFileVersion', label: '파일 버전', class: 'w-10' },
        { key: 'baseYmd', label: '기준년월일', class: 'w-10' },
        { key: 'linkStatus', label: '링크 검증', class: 'w-10' },
        { key: 'action', label: ' ', class: 'w-12' }
      ],
      items: [],
      siteOptions: [],
      mapTypeOptions: [],
      paging: {
        currentPage: 1,
        perPage: 20,
        totalRows: 0,
        pageOptions: [ 10, 20, 50, 100 ]
      }
    }
  },
  mounted () {
    Promise.all([
      this.$http.get('/setting/sites/versions')
        .then((response) => {
          let sites = response.data.result.sites
          let options = [{
            value: '-',
            text: ' - 사이트 - ',
            country: null,
            siteId: '',
            siteVersion: ''
          }]
          for (let i = 0; i < sites.length; i++) {
            sites[i].siteValue = sites[i].siteId + '-' + sites[i].siteVersion
            options.push({
              value: sites[i].siteValue,
              text: (sites[i].siteName + ' (' + sites[i].siteVersion + ')'),
              country: sites[i].country,
              siteId: sites[i].siteId,
              siteVersion: sites[i].siteVersion
            })
          }
          this.$data.siteOptions = options
        })
        .catch((error) => {
          this.$toasted.global.error(this.formatErrorMessage(error))
        }),
      this.$http.get('/setting/mapTypes')
        .then((response) => {
          let mapTypes = response.data.result.mapTypes
          let options = [{
            value: '',
            text: ' - 맵타입 - '
          }]
          for (let i = 0; i < mapTypes.length; i++) {
            options.push({
              value: mapTypes[i].mapTypeId,
              text: mapTypes[i].mapTypeName
            })
          }
          this.$data.mapTypeOptions = options
        })
        .catch((error) => {
          this.$toasted.global.error(this.formatErrorMessage(error))
        })
    ]).then((values) => {
      // 목록조회
      this.fetchList()
    })
  },
  methods: {
    // 데이터파일 목록 조회
    fetchList () {
      this.$data.param.page = this.$data.paging.currentPage - 1
      this.$data.param.size = this.$data.paging.perPage
      this.$http.get('/setting/dataFiles', { params: this.$data.param })
        .then((response) => {
          let dataFiles = response.data.result.dataFiles
          for (let i = 0; i < dataFiles.length; i++) {
            let dataFile = dataFiles[i]
            dataFile.siteValue = dataFile.siteId + '-' + dataFile.siteVersion
          }
          this.$data.items = dataFiles
          this.$data.paging.totalRows = response.data.result.totalCount
        })
        .catch((error) => {
          this.$toasted.global.error(this.formatErrorMessage(error))
        })
    },
    // 폼 입력필드 백그라운드 설정 - 신규 입력필드인 경우 노란색으로 디스플레이
    formBackgroundColor (data) {
      if (data.item.isNewItem) {
        return 'background-color:#fafad2;'
      } else {
        return null
      }
    },
    // 폼필드 읽기전용여부 설정
    formFieldReadOnly (data) {
      if (data.item.isNewItem) {
        return false
      } else {
        return true
      }
    },
    // 맵타입 읽기전용여부 설정
    formMapTypeReadOnly (data) {
      if (data.item.isNewItem) {
        if (data.item.siteId === '') {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    },
    // 타일요청경로 읽기전용여부 설정
    formTileReadOnly (data) {
      if (data.item.fileExtension === 'map' || data.item.dataFileName === 'eDBType_comm_VoiceEx') {
        return false
      } else {
        return true
      }
    },
    // 다운로드경로 읽기전용여부 설정
    formDownloadReadOnly (data) {
      if (data.item.siteId === '') {
        return true
      } else {
        return false
      }
    },
    // 링크검증 배지 색 설정
    linkStatusColor (data) {
      if (data.item.linkStatus === 'OK') {
        return 'success'
      } else if (data.item.linkStatus === 'FAIL') {
        return 'danger'
      } else {
        return 'secondary'
      }
    },
    // 입력값 검증
    validateInput (data) {
      if (data.item.siteId === '') {
        if (data.item.mapTypeId !== '') {
          this.$toasted.global.info('사이트를 "전세계" 선택시 맵타입은 선택 불가능 합니다.')
          return false
        }
      } else {
        if (data.item.mapTypeId === '') {
          this.$toasted.global.info('맵타입을 선택하세요.')
          return false
        }
      }
      if (!data.item.fileExtension) {
        this.$toasted.global.info('파일 확장자를 선택하세요.')
        return false
      }
      if (!data.item.dataFileName || data.item.dataFileName.length < 2 || data.item.dataFileName.length > 50) {
        this.$toasted.global.info('데이터 파일명을 2~50자 이내로 입력하세요.')
        return false
      }
      if (data.item.dataFileName === 'eTileType_' || data.item.dataFileName === 'eDBType_') {
        this.$toasted.global.info('접두사 이후의 데이터 파일명을 입력하세요.')
        return false
      }
      if (data.item.mainVersion === null || data.item.mainVersion === '' || data.item.mainVersion < 0) {
        this.$toasted.global.info('주버전을 입력하세요.')
        return false
      }
      if (data.item.subVersion === null || data.item.subVersion === '' || data.item.subVersion < 0) {
        this.$toasted.global.info('부버전을 입력하세요.')
        return false
      }
      if (!data.item.baseYmd || data.item.baseYmd.length !== 8) {
        this.$toasted.global.info('기준년월일을 YYYYMMDD 포맷의 8자리로 입력하세요.')
        return false
      }
      return true
    },
    // baseDir 이하 URL 경로를 생성한다
    combinePathForUrl (baseDir, data) {
      let hasSite = (data.item.siteId !== '')
      let versionString = 'v' + data.item.mainVersion + '.' + data.item.subVersion
      let country = ''
      if (hasSite) {
        for (let i = 0; i < this.$data.siteOptions.length; i++) {
          if (this.$data.siteOptions[i].value === (data.item.siteId + '-' + data.item.siteVersion)) {
            country = this.$data.siteOptions[i].country + '_'
            break
          }
        }
      }
      if (hasSite) {
        return path.join(baseDir, versionString, country + data.item.mapTypeId, '')
      } else {
        return path.join(baseDir, versionString)
      }
    },
    // 원본파일위치, 타일요청경로, 다운로드경로의 입력값을 변경한다
    remakeChangedPath (isTileUrl, befPath, aftMainVersion, aftSubVersion, aftBaseYmd) {
      let pathStrings = befPath.split('/')
      // pathStrings 는 6의 길이를 갖는 배열 이어야 함
      if (pathStrings.length !== 6) {
        return befPath
      }

      // pathStrings[3] 은 버전 정보가 할당됨 (ex. v4.0)
      if (pathStrings[3].indexOf('v') !== 0) {
        return befPath
      }
      // pathString[3] 의 버전정보 교체
      pathStrings[3] = 'v' + aftMainVersion + '.' + aftSubVersion

      // pathString[5] 의 파일명의 버전정보 교체
      // pathStrings[5] 는 원본파일위치, 다운로드경로는 확장자를 포함한 파일명이 타일요청경로는 확장자가 없는 파일명이 할당됨
      // 원본파일 위치 ex : kor_comm_geo-4_0_20180315.map
      // 타일요청 경로 ex : geo
      // 다운로드 경로 ex : geo-4_0_20180315.map
      if (!isTileUrl) {
        let versionDivIdx = pathStrings[5].lastIndexOf('-')
        let baseYmdDivIdx = pathStrings[5].lastIndexOf('_')
        let dotIdx = pathStrings[5].lastIndexOf('.')
        if (versionDivIdx === -1 || baseYmdDivIdx === -1 || dotIdx === -1) {
          return befPath
        }
        if (versionDivIdx > baseYmdDivIdx || baseYmdDivIdx > dotIdx) {
          return befPath
        }
        let fileNamePrefix = pathStrings[5].substring(0, versionDivIdx)
        let fileNameSuffix = pathStrings[5].substring(dotIdx)
        pathStrings[5] = fileNamePrefix + '-' + aftMainVersion + '_' + aftSubVersion + '_' + aftBaseYmd + fileNameSuffix
      }

      return pathStrings.join('/')
    },

    /**
     * <사이트 관리> 화면 이벤트 처리 메소드
     */
    // 사이트 콤보(검색조건) 변경시
    handleSiteChanged (value) {
      this.$nextTick(() => {
        let idx = value.lastIndexOf('-')
        this.$data.param.searchSiteId = value.substring(0, idx)
        this.$data.param.searchSiteVersion = value.substring(idx + 1)
        this.$data.paging.currentPage = 1
        this.fetchList()
      })
    },
    // 맵타입 콤보(검색조건) 변경시
    handleMapTypeChanged () {
      this.$nextTick(() => {
        this.$data.paging.currentPage = 1
        this.fetchList()
      })
    },
    // 추가 버튼 클릭 시
    handleAddClicked () {
      // 입력 폼은 한건만 디스플레이 한다
      let find = false
      for (let idx in this.$data.items) {
        let item = this.$data.items[idx]
        if (!item.dataFileId) {
          find = true
          break
        }
      }
      if (find) {
        this.$toasted.global.info('한건씩만 입력 가능합니다.')
        return false
      }
      // 빈 아이템 생성
      let emptyItem = {
        siteValue: '-',
        siteId: '',
        siteVersion: '',
        dataFileId: null,
        fileExtension: '',
        mapTypeId: '',
        dataFileName: null,
        mainVersion: 4,
        subVersion: 0,
        baseYmd: null,
        linkStatus: 'UNKNOWN',
        linkStatusMessage: '알수 없음',
        filePath: null,
        tileUrl: null,
        downloadUrl: null,
        _showDetails: true,
        isNewItem: true
      }
      // 배열 맨 앞에 추가한다
      this.$data.items.unshift(emptyItem)
    },
    // 검색어 삭제 버튼 클릭 시
    handleClearClicked (e) {
      this.$data.param.searchWord = null
    },
    // 조회 버튼 클릭 시
    handleSearchClicked (e) {
      this.$data.paging.currentPage = 1
      this.fetchList()
    },
    // 링크 검증 버튼 클릭 시
    handleLinkValidationClicked (e) {
      let msg = '현재 조회 완료된 목록 기준으로, 서버에서 심볼릭 링크가 정상적으로 생성되어 있는지 확인하여 테이블 목록에 표시합니다. ' +
        '링크 검증을 위해서는 데이터 파일별로 (1)원본파일 위치, (2)타일요청 경로 or 다운로드 경로가 등록되어 있어야 합니다.\n\n' +
        '지금 링크 검증을 실행 하시겠습니까?'
      if (!confirm(msg)) {
        return false
      }
      for (let i = 0; i < this.$data.items.length; i++) {
        if (this.$data.items[i].isNewItem) {
          continue
        }
        var url = '/setting/dataFiles/' + this.$data.items[i].dataFileId + '/linkStatus'
        this.$http.get(url)
          .then((response) => {
            var dataFile = response.data.result.dataFile
            this.$data.items[i].linkStatus = dataFile.linkStatus
            this.$data.items[i].linkStatusMessage = dataFile.linkStatusMessage
          })
          .catch((error) => {
            this.$toasted.global.error(this.formatErrorMessage(error))
          })
      }
    },

    // 페이지 버튼 클릭 시
    handleCurrentPageChanged (value) {
      // 이 함수가 호출되는 시점에는 this.$data.paging.currentPage 값이 변경되기 전 값이므로 nextTick 을 이용한다
      this.$nextTick(() => {
        this.fetchList()
      })
    },
    // 페이지당 출력건수 변경 시
    handlePerPageChanged (value) {
      this.$data.paging.currentPage = 1
      // 이 함수가 호출되는 시점에는 this.$data.paging.perPage 값이 변경되기 전 값이므로 nextTick 을 이용한다
      this.$nextTick(() => {
        this.fetchList()
      })
    },

    // 저장 버튼 클릭 시
    handleSaveClicked (data) {
      if (!this.validateInput(data)) {
        return false
      }
      // 신규추가 버튼을 클릭하여 생성된 빈 데이터만 isNewItem 값이 true 임
      if (data.item.isNewItem) {
        this.$http.post('/setting/dataFiles', data.item)
          .then((response) => {
            this.$emit('data-file-item-changed')
            this.$toasted.global.success('저장 되었습니다.')
            this.fetchList()
          })
          .catch((error) => {
            this.$toasted.global.error(this.formatErrorMessage(error))
          })
      } else {
        this.$http.put('/setting/dataFiles/' + data.item.dataFileId, data.item)
          .then((response) => {
            this.$emit('data-file-item-changed')
            this.$toasted.global.success('저장 되었습니다.')
            this.fetchList()
          })
          .catch((error) => {
            this.$toasted.global.error(this.formatErrorMessage(error))
          })
      }
    },
    // 삭제 버튼 클릭 시
    handleDeleteClicked (data) {
      // 신규버튼을 눌러 디스플레이된 로우를 삭제하는 경우
      if (data.item.isNewItem) {
        for (let i = 0; i < this.$data.items.length; i++) {
          if (this.$data.items[i].isNewItem) {
            this.$data.items.splice(i, 1)
            break
          }
        }
        return false
      }
      // 실제 데이터를 삭제하는 경우
      let message = '삭제 작업은 취소가 불가능 하며, 파일 정보를 삭제하더라도 서버에 저장된 파일 및 심볼릭링크 파일은 삭제되지 않습니다. \n\n정말로 ' + data.item.dataFileName + '을(를) 삭제 하시겠습니까? '
      if (confirm(message)) {
        this.$http.delete('/setting/dataFiles/' + data.item.dataFileId)
          .then((response) => {
            this.$emit('data-file-item-changed')
            this.$toasted.global.success('삭제 되었습니다.')
            this.fetchList()
          })
          .catch((error) => {
            this.$toasted.global.error(this.formatErrorMessage(error))
          })
      }
    },
    // 칼럼값 변경에 따른 처리
    handleColumnChanged (data) {
      // 신규등록의 경우에는 사이트 파일확장자, 데이터파일, 주버전, 부버전, 기준년월일 변경시 파일경로, 타일요청경로, 다운로드경로를 초기화 시킨다
      if (data.item.isNewItem) {
        if (data.item.filePath || data.item.tileUrl || data.item.downloadUrl) {
          this.$toasted.global.info('원본파일위치, 타일요청경로 및 다운로드경로가 초기화 됩니다.')
        }
        if (!data.item._showDetails) {
          data.toggleDetails()
        }
        data.item.filePath = null
        data.item.tileUrl = null
        data.item.downloadUrl = null
      // 수정의 경우에는 변경될 값만 찾아서 자동변경한다
      } else {
        if (data.item.filePath) {
          data.item.filePath = this.remakeChangedPath(false, data.item.filePath, data.item.mainVersion, data.item.subVersion, data.item.baseYmd)
        }
        if (data.item.tileUrl) {
          data.item.tileUrl = this.remakeChangedPath(true, data.item.tileUrl, data.item.mainVersion, data.item.subVersion, data.item.baseYmd)
        }
        if (data.item.downloadUrl) {
          data.item.downloadUrl = this.remakeChangedPath(false, data.item.downloadUrl, data.item.mainVersion, data.item.subVersion, data.item.baseYmd)
        }
      }
    },
    // 사이트 입력값 변경시
    handleSiteInputChanged (data) {
      this.$nextTick(() => {
        let idx = data.item.siteValue.lastIndexOf('-')
        data.item.siteId = data.item.siteValue.substring(0, idx)
        data.item.siteVersion = data.item.siteValue.substring(idx + 1)
        data.item.mapTypeId = ''
        data.item.fileExtension = ''
        this.handleFileExtensionChanged(data)
      })
    },
    // 맵타입 값 변경 시
    handleMapTypeInputChanged (data) {
      data.item.fileExtension = ''
      // this.handleColumnChanged(data)
      this.handleFileExtensionChanged(data)
    },
    // 파일 확장자 값 변경 시
    handleFileExtensionChanged (data) {
      this.handleColumnChanged(data)
      this.$nextTick(() => {
        if (data.item.fileExtension === '') {
          data.item.dataFileName = ''
        } else {
          let currDataFileName = data.item.dataFileName
          let baseNameStIdx = currDataFileName ? (currDataFileName.lastIndexOf('_') + 1) : 0
          let baseName = ''
          if (baseNameStIdx > 0) {
            baseName = currDataFileName.substring(baseNameStIdx)
          }
          let mapTypeId = data.item.mapTypeId
          if (mapTypeId !== '') {
            mapTypeId = mapTypeId + '_'
          }
          let prefix
          if (data.item.fileExtension === '') {
            prefix = ''
          } else if (data.item.fileExtension === 'map') {
            prefix = 'eTileType_'
          } else {
            prefix = 'eDBType_'
          }
          data.item.dataFileName = prefix + mapTypeId + baseName
        }
      })
    },

    // 파일 경로 서포트 버튼 클릭
    handleFilePathSupportClicked (data) {
      if (!this.validateInput(data)) {
        return false
      }
      // 디렉토리 경로 구성
      let hasSite = (data.item.siteId !== '')
      let versionString = 'v' + data.item.mainVersion + '.' + data.item.subVersion
      let country = ''
      if (hasSite) {
        for (let i = 0; i < this.$data.siteOptions.length; i++) {
          if (this.$data.siteOptions[i].value === (data.item.siteId + '-' + data.item.siteVersion)) {
            country = this.$data.siteOptions[i].country
            break
          }
        }
      }
      let dirString = path.join('/map/org', versionString, country)
      // 파일명 구성
      let strIdx = data.item.dataFileName.lastIndexOf('_') + 1
      let fileName = data.item.dataFileName.substring(strIdx).toLowerCase()
      // RouteNdb, RouteCfg 예외처리
      if (fileName === 'routendb' || fileName === 'routecfg') {
        fileName = 'route'
      }
      let prefix
      if (hasSite) {
        prefix = country.toLowerCase() + '_' + data.item.mapTypeId.toLowerCase() + '_'
      } else {
        prefix = 'world_'
      }
      let suffix = '-' + data.item.mainVersion + '_' + data.item.subVersion + '_' + data.item.baseYmd + '.' + data.item.fileExtension
      data.item.filePath = path.join(dirString, (prefix + fileName + suffix))
      console.log(data.item.filePath)
    },
    // 파일 경로 지우기 버튼 클릭 시
    handleFilePathClearClicked (data) {
      data.item.filePath = null
    },

    // 타일 URL 작성 서포트 버튼 클릭 시
    handleTileUrlSupportClicked (data) {
      if (!this.validateInput(data)) {
        return false
      }
      let baseDir = this.combinePathForUrl('/map/db/', data)
      let strIdx = data.item.dataFileName.lastIndexOf('_') + 1
      let fileName = data.item.dataFileName.substring(strIdx).toLowerCase()
      data.item.tileUrl = path.join(baseDir, fileName)
    },
    // 타일 URL 지우기 버튼 클릭 시
    handleTileUrlClearClicked (data) {
      data.item.tileUrl = null
    },

    // 다운로드 URL 작성 서포트 버튼 클릭 시
    handleDownloadUrlSupportClicked (data) {
      if (!this.validateInput(data)) {
        return false
      }
      let baseDir = this.combinePathForUrl('/map/update/', data)
      let strIdx = data.item.dataFileName.lastIndexOf('_') + 1
      let fileName = data.item.dataFileName.substring(strIdx).toLowerCase()
      // RouteNdb, RouteCfg 예외처리
      if (fileName === 'routendb' || fileName === 'routecfg') {
        fileName = 'route'
      }
      fileName = fileName + '-' + data.item.mainVersion + '_' + data.item.subVersion + '_' + data.item.baseYmd + '.' + data.item.fileExtension
      data.item.downloadUrl = path.join(baseDir, fileName)
    },
    // 타일 URL 지우기 버튼 클릭 시
    handleDownloadUrlClearClicked (data) {
      data.item.downloadUrl = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/DataFile.vue